module.exports = __webpack_public_path__ + "static/media/dr-venus.7df81a17.png";